import { NgModule } from '@angular/core';
import { ServiceChargeDetailsPipe } from './service-charge-details.pipe';

@NgModule({
  declarations: [ServiceChargeDetailsPipe],
  exports: [ServiceChargeDetailsPipe]
})
export class ServiceChargeDetailsModule {}
